export default class AxiosRequestStrategy {
  success(cfg) {
    return cfg;
  }

  fail(error) {
    throw error;
  }
}
